// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"ffcb0020","140":"5449a013","404":"6a052c94","664":"86189b95","705":"dcc46963","915":"8a3bdc65"}[chunkId] + ".chunk.js";
};